import React, { useState, useEffect } from "react";
import "./Footer.css";
import payment from "../assets/images/payment.png";
import { Link } from "react-router-dom"; //Link
import Accordion from "react-bootstrap/Accordion"; //Accordion
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6"; 
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FiYoutube } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import axios from "../api/axios";

export default function Footer() {
  const [widgetOneTitle, setWidgetOneTitle] = useState("About us");
  const [widgetOneItems, setWidgetOneItems] = useState([]);
  const [widgetTwoTitle, setWidgetTwoTitle] = useState("Categories");
  const [widgetTwoItems, setWidgetTwoItems] = useState([]);
  const [widgetThreeTitle, setWidgetThreeTitle] = useState("Service");
  const [widgetThreeItems, setWidgetThreeItems] = useState([]);
  const [widgetFourTitle, setWidgetFourTitle] = useState("Policies");
  const [widgetFourItems, setWidgetFourItems] = useState([]);

  const [contactAddress, setContactAddress] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");

  const [facebookLink, setFacebookLink] = useState("");
  const [instagramLink, setInstagramLink] = useState("");
  const [linkedinLink, setLinkedinLink] = useState("");
  const [twitterLink, setTwitterLink] = useState("");
  const [youtubeLink, setYoutubeLink] = useState("");

  const [copyrightText, setCopyrightText] = useState("Copyright 2026 Textile. All right reserved.");

  const fallbackW1 = [
    { label: "The Founder", link: "/products" },
    { label: "Contact Us", link: "/products" },
    { label: "Legacy", link: "/products" },
    { label: "Sustainability", link: "/products" },
    { label: "Craftsmanship", link: "/products" },
    { label: "Blog", link: "/products" },
    { label: "Catalogues", link: "/products" }
  ];

  const fallbackW2 = [
    { label: "The Founder", link: "/products" },
    { label: "Contact Us", link: "/products" },
    { label: "Legacy", link: "/products" },
    { label: "Sustainability", link: "/products" },
    { label: "Craftsmanship", link: "/products" },
    { label: "Blog", link: "/products" },
    { label: "Catalogues", link: "/products" }
  ];

  const fallbackW3 = [
    { label: "The Founder", link: "/products" },
    { label: "Contact Us", link: "/products" },
    { label: "Legacy", link: "/products" },
    { label: "Sustainability", link: "/products" },
    { label: "Craftsmanship", link: "/products" },
    { label: "Blog", link: "/products" },
    { label: "Catalogues", link: "/products" }
  ];

  const fallbackW4 = [
    { label: "Terms & Conditions", link: "/terms" },
    { label: "Privacy Policy", link: "/privacy" },
    { label: "The Founder", link: "/products" },
    { label: "Contact Us", link: "/products" },
    { label: "Legacy", link: "/products" },
    { label: "Sustainability", link: "/products" },
    { label: "Craftsmanship", link: "/products" }
  ];

  useEffect(() => {
    const keys = [
      "widget_one", "widget_one_labels", "widget_one_links",
      "widget_two", "widget_two_labels", "widget_two_links",
      "widget_three", "widget_three_labels", "widget_three_links",
      "widget_four", "widget_four_labels", "widget_four_links",
      "contact_address", "contact_phone", "contact_email",
      "facebook_link", "instagram_link", "linkedin_link", "twitter_link", "youtube_link",
      "frontend_copyright_text"
    ].join(",");

    axios.post("/business-settings", { keys })
      .then(response => {
        if (response.data && Array.isArray(response.data)) {
          const findVal = (key) => {
            // First search for English translation/localized version
            let setting = response.data.find(s => s.type === key && s.lang === "en");
            // If not found, look for any non-empty version
            if (!setting) {
              setting = response.data.find(s => s.type === key && s.value !== null && s.value !== "");
            }
            // Fallback to the first match
            if (!setting) {
              setting = response.data.find(s => s.type === key);
            }
            return setting?.value;
          };

          const w1 = findVal("widget_one");
          if (w1) setWidgetOneTitle(w1);
          const w1Labels = findVal("widget_one_labels");
          const w1Links = findVal("widget_one_links");
          if (Array.isArray(w1Labels)) {
            const linksArr = Array.isArray(w1Links) ? w1Links : [];
            setWidgetOneItems(w1Labels.map((lbl, idx) => ({ label: lbl, link: linksArr[idx] || "#" })));
          }

          const w2 = findVal("widget_two");
          if (w2) setWidgetTwoTitle(w2);
          const w2Labels = findVal("widget_two_labels");
          const w2Links = findVal("widget_two_links");
          if (Array.isArray(w2Labels)) {
            const linksArr = Array.isArray(w2Links) ? w2Links : [];
            setWidgetTwoItems(w2Labels.map((lbl, idx) => ({ label: lbl, link: linksArr[idx] || "#" })));
          }

          const w3 = findVal("widget_three");
          if (w3) setWidgetThreeTitle(w3);
          const w3Labels = findVal("widget_three_labels");
          const w3Links = findVal("widget_three_links");
          if (Array.isArray(w3Labels)) {
            const linksArr = Array.isArray(w3Links) ? w3Links : [];
            setWidgetThreeItems(w3Labels.map((lbl, idx) => ({ label: lbl, link: linksArr[idx] || "#" })));
          }

          const w4 = findVal("widget_four");
          if (w4) setWidgetFourTitle(w4);
          const w4Labels = findVal("widget_four_labels");
          const w4Links = findVal("widget_four_links");
          if (Array.isArray(w4Labels)) {
            const linksArr = Array.isArray(w4Links) ? w4Links : [];
            setWidgetFourItems(w4Labels.map((lbl, idx) => ({ label: lbl, link: linksArr[idx] || "#" })));
          }

          const addr = findVal("contact_address");
          if (addr) setContactAddress(addr);
          const ph = findVal("contact_phone");
          if (ph) setContactPhone(ph);
          const em = findVal("contact_email");
          if (em) setContactEmail(em);

          const fb = findVal("facebook_link");
          if (fb) setFacebookLink(fb);
          const insta = findVal("instagram_link");
          if (insta) setInstagramLink(insta);
          const ln = findVal("linkedin_link");
          if (ln) setLinkedinLink(ln);
          const tw = findVal("twitter_link");
          if (tw) setTwitterLink(tw);
          const yt = findVal("youtube_link");
          if (yt) setYoutubeLink(yt);

          const cr = findVal("frontend_copyright_text");
          if (cr) setCopyrightText(cr);
        }
      })
      .catch(err => {
        console.error("Error fetching settings in Footer", err);
      });
  }, []);

  const renderLinkItems = (items, fallback) => {
    const list = items && items.length > 0 ? items : fallback;
    return list.map((item, index) => {
      const linkVal = item.link || "#";
      const isExternal = typeof linkVal === "string" && (linkVal.startsWith("http://") || linkVal.startsWith("https://"));
      return (
        <li key={index}>
          {isExternal ? (
            <a href={linkVal} target="_blank" rel="noopener noreferrer">
              {item.label}
            </a>
          ) : (
            <Link to={linkVal}>{item.label}</Link>
          )}
        </li>
      );
    });
  };

  return (
    <div className="footer_outer">
      <div className="footer_main">
        <div className="container-fluid">
          <div className="row footer_links_row">
            <div className="col-lg-8 col-md-8 col-sm-12 col-12">
              <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                  <div className="footer_item">
                    <h5>{widgetOneTitle}</h5>
                    <ul>
                      {renderLinkItems(widgetOneItems, fallbackW1)}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                  <div className="footer_item">
                    <h5>{widgetTwoTitle}</h5>
                    <ul>
                      {renderLinkItems(widgetTwoItems, fallbackW2)}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                  <div className="footer_item">
                    <h5>{widgetThreeTitle}</h5>
                    <ul>
                      {renderLinkItems(widgetThreeItems, fallbackW3)}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                  <div className="footer_item">
                    <h5>{widgetFourTitle}</h5>
                    <ul>
                      {renderLinkItems(widgetFourItems, fallbackW4)}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-12">
              <div className="footer_item">
                <h5>Subscribe To Newsletter</h5>
                <form className="d-flex" role="search">
                  <input
                    className="form-control"
                    type="search"
                    aria-label="Search"
                    placeholder="Email"
                  />
                  <button className="" type="submit">
                    Subscribe
                  </button>
                </form>
              </div>

              <div className="footer_item footer_item_contact">
                <h5>Contact Us</h5>
                <ul>
                  {contactAddress && (
                    <li style={{ color: "#fff", fontSize: "14px", marginBottom: "8px" }}>
                      {contactAddress}
                    </li>
                  )}
                  <li>
                    <a href={`tel:${contactPhone || "+918739990555"}`}>
                      {contactPhone || "+91 87399 90555"}
                    </a>
                  </li>
                  <li>
                    <a href={`mailto:${contactEmail || "textile@gmail.com"}`}>
                      {contactEmail || "textile@gmail.com"}
                    </a>
                  </li>
                </ul>

                <div className="social_icons">
                  <ul>
                    {facebookLink && (
                      <li>
                        <a href={facebookLink} target="_blank" rel="noopener noreferrer">
                          <FaFacebookF />
                        </a>
                      </li>
                    )}
                    {instagramLink && (
                      <li>
                        <a href={instagramLink} target="_blank" rel="noopener noreferrer">
                         <FaInstagram />
                        </a>
                      </li>
                    )}
                    {linkedinLink && (
                      <li>
                        <a href={linkedinLink} target="_blank" rel="noopener noreferrer">
                          <FaLinkedinIn />
                        </a>
                      </li>
                    )}
                    {twitterLink && (
                      <li>
                        <a href={twitterLink} target="_blank" rel="noopener noreferrer">
                         <FaXTwitter />
                        </a>
                      </li>
                    )}
                    {youtubeLink && (
                      <li>
                        <a href={youtubeLink} target="_blank" rel="noopener noreferrer">
                         <FiYoutube />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="mobile_footer_accord ">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                <Accordion.Header>{widgetOneTitle}</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    {renderLinkItems(widgetOneItems, fallbackW1)}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>{widgetTwoTitle}</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    {renderLinkItems(widgetTwoItems, fallbackW2)}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>{widgetThreeTitle}</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    {renderLinkItems(widgetThreeItems, fallbackW3)}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4">
                <Accordion.Header>{widgetFourTitle}</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    {renderLinkItems(widgetFourItems, fallbackW4)}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div className="subscribe_mobile_footer">
              <div className="footer_item">
                <h5>Subscribe To Newsletter</h5>
                <form className="d-flex" role="search">
                  <input
                    className="form-control"
                    type="search"
                    aria-label="Search"
                    placeholder="Email"
                  />
                  <button className="" type="submit">
                    Subscribe
                  </button>
                </form>
              </div>

              <div className="footer_item footer_item_contact">
                <h5>Contact Us</h5>
                <ul>
                  {contactAddress && (
                    <li style={{ color: "#fff", fontSize: "14px", marginBottom: "8px" }}>
                      {contactAddress}
                    </li>
                  )}
                  <li>
                    <a href={`tel:${contactPhone || "+918739990555"}`}>
                      {contactPhone || "+91 87399 90555"}
                    </a>
                  </li>
                  <li>
                    <a href={`mailto:${contactEmail || "textile@gmail.com"}`}>
                      {contactEmail || "textile@gmail.com"}
                    </a>
                  </li>
                </ul>

                <div className="social_icons">
                   <ul>
                    {facebookLink && (
                      <li>
                        <a href={facebookLink} target="_blank" rel="noopener noreferrer">
                          <FaFacebookF />
                        </a>
                      </li>
                    )}
                    {instagramLink && (
                      <li>
                        <a href={instagramLink} target="_blank" rel="noopener noreferrer">
                         <FaInstagram />
                        </a>
                      </li>
                    )}
                    {linkedinLink && (
                      <li>
                        <a href={linkedinLink} target="_blank" rel="noopener noreferrer">
                          <FaLinkedinIn />
                        </a>
                      </li>
                    )}
                    {twitterLink && (
                      <li>
                        <a href={twitterLink} target="_blank" rel="noopener noreferrer">
                         <FaXTwitter />
                        </a>
                      </li>
                    )}
                    {youtubeLink && (
                      <li>
                        <a href={youtubeLink} target="_blank" rel="noopener noreferrer">
                         <FiYoutube />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer_copyright">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6">
              <div className="copyright_text">
                <p dangerouslySetInnerHTML={{ __html: copyrightText || "Copyright 2026 Textile. All right reserved." }} />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="copyright_text text-end">
                <a href="#">
                  <img src={payment} alt="payment" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
